import optionsFilterComponentUrl from './optionsFilterComponent.html';
class OptionsFilterController {
  constructor(Authentication, SidebarFiltersService, $timeout, $rootScope, sdk) {
    'ngInject';

    Object.assign(this, { Authentication, SidebarFiltersService, $timeout, $rootScope, sdk });
  }

  $onInit() {
    const instance = this;
    const { PROCESSING_MODES } = this.sdk('constants');

    this.optionsDictionary = [
      {
        name: 'showEmptyRows',
        title: 'Empty rows',
        get hidden() {
          return instance.processingMode === 'user-aggregated';
        },
      },
      {
        name: 'showPlanningEvents',
        title: 'Unpublished shifts',
        get hidden() {
          return (
            !instance.Authentication.user.isManager ||
            instance.displayTab === 'availability' ||
            instance.displayTab === 'pendingapproval'
          );
        },
      },
      {
        name: 'showCountOfHours',
        title: 'Count of hours',
        get hidden() {
          return instance.displayTab === 'availability';
        },
      },
      {
        name: 'showLaborPercentage',
        title: 'Labor %',
        get hidden() {
          return (
            instance.displayTab === 'availability' ||
            !instance.Authentication.user.wouldHaveAccessToLaborCost
          );
        },
      },
      {
        name: 'showLaborCost',
        title: 'Labor cost',
        get hidden() {
          return (
            instance.displayTab === 'availability' ||
            !instance.Authentication.user.wouldHaveAccessToLaborCost
          );
        },
      },
      {
        name: 'showProjectedSales',
        title: 'Projected sales',
        get hidden() {
          return instance.displayTab === 'availability' || instance.projectedSalesOptionHidden;
        },
      },
      {
        name: 'showForeignShifts',
        title: 'Conflicts',
        get hidden() {
          return (
            instance.displayTab === 'availability' ||
            instance.processingMode === PROCESSING_MODES.USER_AGGREGATED
          );
        },
      },
    ];
  }

  get hiddenSidebar() {
    return this.SidebarFiltersService.hiddenSidebar;
  }

  get conflictsTooltip() {
    let where;
    if (/^(location|position)$/.test(this.sortMethod)) {
      where = `other ${this.sortMethod}s`;
    } else {
      where = 'hidden locations and positions';
    }

    return `With this option enabled you can see events from ${where} so you can avoid double-bookings`;
  }

  optionChanged(optionName) {
    this.SidebarFiltersService.optionChanged(optionName);
  }

  isExpanded() {
    return this.SidebarFiltersService.filtersExpansion.optionsFiltersExpanded;
  }

  optionsFilterClicked() {
    this.SidebarFiltersService.filterHeaderClicked('option');
  }
}

export default {
  controller: OptionsFilterController,
  controllerAs: 'ctrl',
  templateUrl: optionsFilterComponentUrl,
  bindings: {
    displayMode: '<',
    processingMode: '<',
    displayTab: '<',
    sortMethod: '<',
    whoseEvents: '<',
    users: '<',
    optionsFilterState: '<',
    projectedSalesOptionHidden: '<',
  },
};
